import { SMART_TV_BROADCAST_ERRORED, SMART_TV_BROADCAST_LOADING } from './types';
import { SOCKET_URL, SOCKET_URL_STAGING, SOCKET_URL_V2, SOCKET_URL_STAGING_V2 } from '../constants'

/////////////////////////////
// BROADCAST PIN BY SOCKET //
/////////////////////////////


export function broadcastProcessedPin(clientSocketId, token, dispatchSuccess, V2=false) {

    /* Intrudction V2 flag for changes with the new Socket updates */
    const socketUrl = V2 ? SOCKET_URL_V2 : SOCKET_URL;
    const socketUrl_stage = V2 ? SOCKET_URL_STAGING_V2 : SOCKET_URL_STAGING;
    const url = (window.ENV_ID === 'live')?socketUrl:socketUrl_stage;

    let data = {};
    if(V2) {
        data = { "message": { "tokenId": token, "connectionId": clientSocketId }};
    } else {
        data = { "clientSocketId": clientSocketId, "token": token };
    }
    return function(dispatch, getState) {
        dispatch({type: SMART_TV_BROADCAST_LOADING, payload:true});
        dispatch({ type: SMART_TV_BROADCAST_ERRORED, payload: false });
        return fetch(url, {
            method: "POST",
            accept: 'application/json',
            body: JSON.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
            })
            .then((response) => {
                dispatch({type: SMART_TV_BROADCAST_LOADING, payload:false});
                if (!response.ok && response.status !== 400 ) { // 400 are special cases and we want the error message from them
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.text())
            .then((item) => {
                let itemObj = JSON.parse(item); 
                if (itemObj.status === "success") {      
                    dispatchSuccess(itemObj,dispatch);
                }else if (itemObj.status === "error" && itemObj.message){
                    errorHandler(dispatch, decodeURIComponent(itemObj.message), getState().uiStrings[getState().curLang])
                } else {
                    errorHandler(dispatch, 'genericError', getState().uiStrings[getState().curLang])
                }     
            },(error) => {
                dispatch({type: SMART_TV_BROADCAST_LOADING, payload:false});
                errorHandler(dispatch, error.toString(), getState().uiStrings[getState().curLang])
            });
    }
}

function errorHandler(dispatch, errorMessage, strings){
    window.console.log("SMART TV SOCKET::ERROR::"+errorMessage);
    let errorMessageTrans = (strings[errorMessage])?strings[errorMessage]:errorMessage; // if a string exists use it other go as is
    dispatch({ type: SMART_TV_BROADCAST_ERRORED, payload: errorMessageTrans });
    if(window.logError){
            window.logError("Error SMARTTVSOCKET ", errorMessage, "SmartTVSocketActions.js");
    }
}